import { getRouteUrl, getUmbrellaRouteUrl } from '@nackle/service-urls';

let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

if ( env === 'localhost' ) {
    env = 'qa';
}

export const currentEnv = env;

function getURL( routeAlias, isUmbrella ) {
    if ( isUmbrella ) {
        return getUmbrellaRouteUrl( routeAlias );
    }
    return getRouteUrl( routeAlias );
}

export const getCashierUrl = ( isUmbrella ) => getURL( 'CASHIER', isUmbrella );
export const getWebEventProxyUrl = ( isUmbrella ) => getURL( 'WEB_EVENT_PROXY', isUmbrella );
